const NELKO_CART_TOAST_HIDE_DELAY = 2600
let nelkoCartToastTimer = null

/**
 * 获取 Header 中的加购提示元素
 */
function getNelkoCartToast() {
  return document.querySelector('[data-nelko-cart-toast]')
}

/**
 * 隐藏 Header Bag 下方的加购提示
 * @param {HTMLElement | null} toast 加购提示元素
 */
function hideNelkoCartToast(toast = getNelkoCartToast()) {
  if (!toast) return

  toast.classList.remove('is-active')

  window.setTimeout(() => {
    if (!toast.classList.contains('is-active')) {
      toast.hidden = true
    }
  }, 180)
}

/**
 * 展示 Header Bag 下方的加购提示
 */
function showNelkoCartToast() {
  const toast = getNelkoCartToast()
  if (!toast) return

  window.clearTimeout(nelkoCartToastTimer)
  toast.hidden = false

  window.requestAnimationFrame(() => {
    toast.classList.add('is-active')
  })

  nelkoCartToastTimer = window.setTimeout(() => {
    hideNelkoCartToast(toast)
  }, NELKO_CART_TOAST_HIDE_DELAY)
}

document.addEventListener('nelko:cart-added', () => {
  showNelkoCartToast()
})
